import 'core-js/es/promise';

// Registers a small dev-time hack that rewrites absolute
// enterpriseportal-*.accuweather.com URLs to same-origin paths.
// Some backend APIs already return absolute URLs; when running on localhost
// or outside the enterpriseportal domain those requests bypass the local
// proxy and fail with CORS. This interceptor keeps those calls working
// without changing backend responses.
import "./axiosConfig";

// Actions
import clientActions from './actions/clientActions';
import mapActions from './actions/mapActions';
import mapInspectActions from './actions/mapInspectActions';
import mapSetActions from './actions/mapSetActions';
import mapViewActions from './actions/mapViewActions';
import portalActions from './actions/portalActions';
import productActions from './actions/productActions';
import productEventActions from './actions/productEventActions';
import severityActions from './actions/severityActions';
import sopActions from './actions/sopActions';
import soundActions from './actions/soundActions';
import userActions from './actions/userActions';
import notificationActions from './actions/notificationActions';
import auditLogActions from './actions/auditLogActions';
import accessLogActions from './actions/aes-tools/accessLogActions';

// Reducers
import productsReducer from './reducers/productsReducer';
import currentProductReducer from './reducers/currentProductReducer';
import userInfoReducer from './reducers/user/infoReducer';
import userContextReducer from './reducers/user/contextReducer';
import userReducer from './reducers/user';
import clientReducer from './reducers/client';
import sopListReducer from './reducers/client/sops/sopListReducer';
import currentSopReducer from './reducers/client/sops/currentSopReducer';
import sopReducer from './reducers/client/sops';
import clientInfoReducer from './reducers/client/infoReducer';
import mapReducer from './reducers/mapReducer';
import mapInspectReducer from './reducers/mapInspectReducer';
import mapQuickSearchReducer from './reducers/mapQuickSearchReducer';
import mapPinReducer from './reducers/mapPinReducer';
import mapSetReducer from './reducers/mapSetReducer';
import mapViewReducer from './reducers/mapViewReducer';
import notificationsReducer from './reducers/notificationsReducer';
import auditLogReducer from './reducers/auditLogReducer';
import accessLogReducer from './reducers/aes-tools/accessLogReducer';
import aesToolsReducer from './reducers/aes-tools';

// Selectors
import userSelectors from './selectors/userSelectors';
import productsSelectors from './selectors/productsSelectors';
import contextSelectors from './selectors/contextSelectors';
import currentProductSelectors from './selectors/currentProductSelectors';
import notificationsSelectors from './selectors/notificationsSelectors';
import mapSelectors from './selectors/mapSelectors';
import mapQuickSearchSelectors from './selectors/mapQuickSearchSelectors';
import mapSetSelectors from './selectors/mapSetSelectors';
import mapViewSelectors from './selectors/mapViewSelectors';
import auditLogSelectors from './selectors/auditLogSelectors';

// APIs
import productApi from './apis/productApi';
import userApi from './apis/userApi';
import sopApi from './apis/sopApi';
import severityApi from './apis/severityApi';
import clientApi from './apis/clientApi';
import mapApi from './apis/mapApi';
import mapInspectApi from './apis/mapInspectApi';
import mapQuickSearchApi from './apis/mapQuickSearchApi';
import mapLayerApi from './apis/mapLayerApi';
import mapSetApi from './apis/mapSetApi';
import mapViewApi from './apis/mapViewApi';
import auditLogApi from './apis/auditLogApi';
import accessLogApi from './apis/accessLogApi';

// Utils
import userUtils from './utils/userUtils';
import genericProductUtils from './utils/genericProduct';
import { preferenceUtils } from './utils/preferenceUtils';

// Constants
import aesReduxConstants from './constants';
import { ApiKey } from './api';

// Middleware
import * as middleware from './middleware';

export const AccuWeatherApiKey = ApiKey;
export { publicWarningStartTime } from './utils/publicWarningTime';

export {
  // Actions
  clientActions,
  mapActions,
  mapInspectActions,
  mapSetActions,
  mapViewActions,
  portalActions,
  productActions,
  productEventActions,
  severityActions,
  sopActions,
  soundActions,
  userActions,
  notificationActions,
  auditLogActions,
  accessLogActions,
  productsReducer,
  currentProductReducer,
  userInfoReducer,
  userContextReducer,
  userReducer,
  clientReducer,
  sopListReducer,
  currentSopReducer,
  sopReducer,
  clientInfoReducer,
  mapReducer,
  mapInspectReducer,
  mapQuickSearchReducer,
  mapPinReducer,
  mapSetReducer,
  mapViewReducer,
  notificationsReducer,
  auditLogReducer,
  accessLogReducer,
  aesToolsReducer,

  // Selectors
  userSelectors,
  productsSelectors,
  contextSelectors,
  currentProductSelectors,
  notificationsSelectors,
  mapSelectors,
  mapQuickSearchSelectors,
  mapSetSelectors,
  mapViewSelectors,
  auditLogSelectors,

  // APIs
  productApi,
  userApi,
  sopApi,
  severityApi,
  clientApi,
  mapApi,
  mapInspectApi,
  mapQuickSearchApi,
  mapLayerApi,
  mapSetApi,
  mapViewApi,
  auditLogApi,
  accessLogApi,

  // Utils
  userUtils,
  preferenceUtils,
  genericProductUtils,

  // Constants
  aesReduxConstants,
  ApiKey,

  // Middleware
  middleware,
};

export { parseNotificationTime, formatNotificationTime, notificationTimeFormat } from './utils/notificationTime';
